import { useAppSelector } from '@/redux/hooks';
import { getFeaturedAuctioneers } from '@/redux/modules/home/home.selectors';
import { useHomePageRedesignExperiment } from '@/utils/amplitude/experiments/hooks/useHomePageRedesign.experiment';

import { FeaturedAuctioneersCarousel } from './FeaturedAuctioneersCarousel';
import { FeaturedAuctioneersGrid } from './FeaturedAuctioneersGrid';

export const FeaturedAuctioneers = () => {
    const featuredAuctioneers = useAppSelector(getFeaturedAuctioneers) ?? [];
    const shouldUseHomePageRedesign = useHomePageRedesignExperiment();

    if (shouldUseHomePageRedesign) {
        return <FeaturedAuctioneersGrid featuredAuctioneers={featuredAuctioneers} />;
    }

    return <FeaturedAuctioneersCarousel featuredAuctioneers={featuredAuctioneers} />;
};
